Core.PackinglistRouter = Core.SubRouter.extend({
    routes: {

        '': 'defaultView',
        'job/:id': 'viewJob',
        'route/:id': 'viewRoute',

    },

    defaultView: function () {
        debug.log('Packinglist default');
        var view = new PackingListsView({});
        app.setMainView(view);
    },

    viewJob: function (id) {
        debug.log('Packinglist job:', id);
        var view = new PackingListsView({});
        var ids = id.split(',');
        _(ids).each(function(id) { view.addJob(id); });
        app.setMainView(view, 'jobs');
    },

    viewRoute: function (id) {
        debug.log('Packinglist route:', id);
        var view = new PackingListsView({});
        view.addRoute(id);
        app.setMainView(view, 'routes');
    }
});
